module.exports = __webpack_public_path__ + "img/marilyn-monroe.ce044194.png";